module.exports = __webpack_public_path__ + "img/deal-inverted.ea7aca99.png";